import { GET_MPI_ELEMENT_SUCCESS } from "../actions";

export const mpiElementReducer = (state = {}, action: any) => {
  switch (action.type) {
    case GET_MPI_ELEMENT_SUCCESS:
      return {
        ...state,
        mpiElement: action.payload,
      };
    default:
      return state;
  }
};
